<footer id="footer">
  <div class="wrap">
    <div class="foot-grid">
      <div class="foot-about">
        <a href="#" class="logo">
          <img
            style="width: 48px; height: 48px"
            src="assets/logo/logo.webp"
            alt=""
          />
          ConnectNow
        </a>
        <p>
          An AI-driven virtual call center seamlessly blending automated voice
          support with real-time human assistance — ensuring smooth, efficient
          customer interactions.
        </p>
        <div class="socials">
          <a href="https://in.linkedin.com/company/kayool" aria-label="LinkedIn"
            ><svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M4.98 3.5A2.5 2.5 0 102.5 6 2.5 2.5 0 004.98 3.5zM3 8h4v13H3zM9 8h3.8v1.8h.05A4.17 4.17 0 0116.5 7.6c4 0 4.7 2.6 4.7 6V21h-4v-6c0-1.4 0-3.3-2-3.3s-2.3 1.6-2.3 3.2V21H9z"
              /></svg
          ></a>
          <a
            href="https://www.facebook.com/people/Connectnowai/61568059334559/"
            aria-label="Facebook"
            ><svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M14 8h3V4h-3c-2.2 0-4 1.8-4 4v2H7v4h3v8h4v-8h3l1-4h-4V8c0-.6.4-1 1-1z"
              /></svg
          ></a>
          <a
            href="https://www.instagram.com/connectnowai/"
            aria-label="Instagram"
            ><svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="5"
                stroke="currentColor"
                stroke-width="1.8"
              />
              <circle
                cx="12"
                cy="12"
                r="4"
                stroke="currentColor"
                stroke-width="1.8"
              />
              <circle cx="17" cy="7" r="1.2" fill="currentColor" /></svg
          ></a>
        </div>
      </div>
      <div class="foot-col">
        <h5>Contact</h5>
        <ul>
          <li><a href="tel:+18065904952">+1 806 590 4952</a></li>
          <li>
            <a href="mailto:contact@connectnow.ai">contact&#64;connectnow.ai</a>
          </li>
        </ul>
      </div>
      <div class="foot-col">
        <h5>Useful Links</h5>
        <ul>
          <li><a href="#">Home</a></li>
          <li><a href="#how">Features</a></li>
          <li><a href="#benefits">Benefits</a></li>
          <li><a href="https://help.connectnow.ai">Help Center</a></li>
          <li>
            <a href="https://connectnow.ai/privacy-policy">Privacy Policy</a>
          </li>
        </ul>
      </div>
      <div class="foot-col">
        <h5>Download App</h5>
        <div class="foot-store">
          <a
            href="https://play.google.com/store/apps/details?id=com.kayool.kayoolshop"
            ><svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M3.6 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l9-9.7-9-9.7zM15.5 9.2l-2.4-1.4-2.8 3 2.8 3 2.5-1.4c1-.6 1-2.2-.1-2.8z"
              /></svg
            ><span><small>Get it on</small>Google Play</span></a
          >
          <a href="https://apps.apple.com/us/app/connectnow-ai/id1670078798"
            ><svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M16.5 1.5c0 1.3-.5 2.4-1.4 3.3-1 1.1-2.2 1.7-3.4 1.6-.1-1.3.5-2.5 1.4-3.4.9-.9 2.3-1.5 3.4-1.5zM20 17c-.5 1.2-.8 1.7-1.5 2.8-1 1.5-2.4 3.4-4.1 3.4-1.5 0-1.9-1-4-1-2 0-2.5 1-4 1-1.7 0-3-1.7-4-3.2-2.8-4.3-3.1-9.3-1.4-12 1.2-1.9 3.1-3 4.9-3 1.8 0 3 1 4.5 1 1.5 0 2.4-1 4.5-1 1.6 0 3.2.9 4.4 2.3-3.9 2.1-3.2 7.6.7 9.9z"
              /></svg
            ><span><small>Download on</small>App Store</span></a
          >
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      ConnectNow. © Copyright 2025. All Rights Reserved.
    </div>
  </div>
</footer>
